import common from '../pl/common.json';
import details from '../pl/details.json';

export default {
  common,
  details,
};
